import React from 'react';
import { SvgLunker } from './svg_lunker';

interface LunkerPotentialProps {
  year?: number | string;
}

export const LunkerPotential = (prop: LunkerPotentialProps) => {
  const { year } = prop;
  return (
    <span className="bg-[#8800FF] text-white rounded-full font-medium px-3 p-1 leading-normal flex items-center gap-1">
      <SvgLunker width={16} height={16} /> Lunker Potential {year}
    </span>
  );
};
